import { Component, computed, inject, input } from '@angular/core';
import { AssetService } from '../services/asset-service/asset.service';
import { AssetListRequestQueryParams } from '../services/asset-service/types';
import { AssetCard } from './asset-card/asset-card';
import { AssetCardSkeleton } from './asset-card-skeleton/asset-card-skeleton';

@Component({
  selector: 'asset-card-list',
  template: `
    <div class="container" [class]="isMoreThanFour() ? 'two-rows' : 'one-row'">
      @if (assetList.isLoading()) {
        <asset-card-skeleton />
      } @else {
        @for (asset of assetList.value()?.items; track asset.asset_id) {
          <asset-card [asset]="asset" />
        }
      }
    </div>
  `,
  styles: `
    :host {
      padding: 20px;
      overflow-x: auto;
    }
    .container {
      width: fit-content;
      gap: 8px;
      &.one-row {
        display: flex;
      }
      &.two-rows {
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: repeat(2, 1fr);
      }
    }
  `,
  imports: [AssetCard, AssetCardSkeleton],
})
export class AssetCardList {
  private assetService = inject(AssetService);

  readonly assetListParams = input.required<AssetListRequestQueryParams>();

  readonly assetList = this.assetService.getOnlySpecifiedAssetListById(this.assetListParams);

  isMoreThanFour = computed(() => {
    if (!this.assetList.hasValue()) return false;
    return this.assetList.value().total > 4;
  });
}
